import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  automaticConciliacao(prestadorId: string) {
    return api.post(`/conciliacao/prestador/${prestadorId}`, null)
  },

  getRecebimentos(medicoId) {
    return api.get(`conciliacao/recebimentos/${medicoId}`)
  },

  manualConciliar(producaoId, sequencia, recebimentosId) {
    return api.post(`/conciliacao/${producaoId}/${sequencia}`, recebimentosId)
  },

  saveConciliacaoManual(producaoId: String, producaoProcedimentoId: String, recebimentosId: any[]) {
    return api.post(`/conciliacao/${producaoId}/procedimento/${producaoProcedimentoId}`, recebimentosId)
  },
}
